const zoneRouter = [
  {
    path: "list-zone",
    name: "zone",
    component: () => import("@/views/admin/zone"),
    default: true,
    meta: {
      model: "zone",
    },
  },
  {
    path: "list-zone/add",
    name: "addZone",
    component: () => import("@/views/admin/zone/function"),
    default: true,
    meta: {
      model: "zone",
    },
  },
  {
    path: "list-zone/edit/:id",
    name: "editZone",
    component: () => import("@/views/admin/zone/function"),
    default: true,
    meta: {
      model: "zone",
    },
  },
];

export default zoneRouter;
